/**
 * FOREFRONT Sow Prosperous
 *
 * @author Chris Tang <chris.tang@forefront.com.my>
 * @organization FOREFRONT International
 */

// Import polyfills
import 'core-js/library/fn/promise';
import 'core-js/library/fn/array/find-index';
import 'core-js/library/fn/array/find';
import 'core-js/library/fn/array/from';

// Import modules
import MoveTo from 'moveto';
import Form from './lib/Form';
import AOS from 'aos';
import axios from 'axios';
import Embedo from 'embedo';
import Instafeed from 'instafeed.js';
import Foresight from 'foresight';

window.addEventListener('DOMContentLoaded', main);

let foresight;

/**
 * The website's script entry point. This method is automatically executed when
 * the DOM is fully loaded.
 */
function main() {
  if ( $("body").hasClass("page-home") ) {
    enableNavigationMenu();
    enableVideo();
    enableScrollTo();
    enableForm();
  } else if ( $("body").hasClass("page-gallery") ) {
    enableIG();
  }

  // Enable T&C button behaviour
  $('#tnc-btn').on('click', function() {
    $('#section-instructions-outer-btn').click();
  });

  // Enable Foresight (JavaScript analytics tracking library)
  foresight = new Foresight();

  // Enable animate on scroll
  AOS.init({ once: true });

  // Disable Google Analytics during development
  if (process.env.NODE_ENV !== 'production') {
    window['ga-disable-UA-26680473-11'] = true;
    console.warn('[WARNING] You are using the developmental build with certain functions disabled. Please run `gulp build -p` for the production build.');
  }
}


/**
 * Enables the navigation menu.
 */
function enableNavigationMenu() {
  const hamburger = document.getElementById('hamburger-btn');
  const menu = document.getElementById('nav-menu');
  const linksMenu = document.getElementById('nav-menu-links');

  if (!hamburger || !menu) { return; }

  const bodyListener = (e) => {
    if (menu.contains(e.target) && !linksMenu.contains(e.target)) {
      return;
    }
    $(menu).removeClass('is-active');
    $(hamburger).removeClass('is-active');
    $(hamburger).attr('aria-expanded', 'false');
    document.body.classList.remove('has-nav-open');
    window.removeEventListener('click', bodyListener);
    document.removeEventListener('keyup', escListener);
  }

  const escListener = (e) => {
    if (e.keyCode !== 27) return;
    $(menu).removeClass('is-active');
    $(hamburger).removeClass('is-active');
    $(hamburger).attr('aria-expanded', 'false');
    document.body.classList.remove('has-nav-open');
    window.removeEventListener('click', bodyListener);
    document.removeEventListener('keyup', escListener);
  }
  
  $(hamburger).on('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (menu.classList.contains('is-active')) {
      $(menu).removeClass('is-active');
      $(hamburger).removeClass('is-active');
      $(hamburger).attr('aria-expanded', 'false');
      document.body.classList.remove('has-nav-open');
      window.removeEventListener('click', bodyListener);
      document.removeEventListener('keyup', escListener);
    } else {
      $(menu).addClass('is-active');
      $(hamburger).addClass('is-active');
      $(hamburger).attr('aria-expanded', 'true');
      document.body.classList.add('has-nav-open');
      window.addEventListener('click', bodyListener);
      document.addEventListener('keyup', escListener);
    }
  });
}


/**
 * Enable the video player.
 */
function enableVideo() {
  let player;
  let hasSentEvent;

  window['onYouTubeIframeAPIReady'] = function() {
    player = new YT.Player('player', {
      videoId: 'MXmGi-Q5zNU',
      playerVars: {
        enablejsapi: 1,
        rel: 0,
        modestbranding: 1,
      },
      events: {
        onStateChange: (event) => {
          if (event.data === YT.PlayerState.PLAYING && !hasSentEvent) {
            foresight.send({
              category: 'Campaign',
              action: 'Watch Video',
              label: '#keepitKAMing'
            });
            hasSentEvent = true;
          }
        }
      }
    });
  }
}


/**
 * Enable Instagram feed
 */
function enableIG() {

  // Get URL
  const fbApi = "https://www.facebook.com/plugins/video/oembed.json/";
  const fbPath = "?url=";
  const fbLink = "https://www.facebook.com/";
  const igPostLink = "https://instagram.com/p/";
  const igApi = "https://api.instagram.com/oembed";
  const igPath = "?url=http://instagr.am/p/";
  const urlContainer = []
  let postID = [
    "BsnKow9HI2r",
    "BskD6PKAOGxAvoS7OSrYkZENeuJ9b__Kzo2h3w0",
    "Bshjfzqnuwi",
    "BsZc_eNnrs-"
  ];

  // Click to load more
  // const fbURLs = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  // const showAmount = 3; // Showing number of post
  // let division = Math.ceil( fbURLs.length/showAmount ); // Get row number
  // let counter = 0;

  // function loadoEmbedContent() {
  //   if ( counter < division ) {
  //     counter++;
  //   }
  //   for (let i = 0 + showAmount*(counter-1); i < showAmount * counter; i++) {
  //     console.log(fbURLs[i]);
  //   }
  // }
  // loadoEmbedContent();
  // $("#section-gallery-more-btn").click( () => {
  //   loadoEmbedContent();
  //   var tryID = $("[data-link").attr;
  //   console.log(tryID);
  //   return false;
  // });

  // // Checking FB post number
  // fbLoaded.promise.then( () => {
  //   var socialContainer = document.getElementById("socialfeed");
  //   var nodelist = socialContainer.getElementsByClassName("card");
  //   console.log(nodelist.length);
  // });

  // Loop all post
  for (let j = 0; j < postID.length; j++ ){
    let fullUrl = igApi + igPath + postID[j];
    urlContainer.push(fullUrl);

    const request = axios.get(fullUrl);
    const instaCotaniner = document.querySelector("#socialfeed");

    // Handle Request
    request.then((response) => {
        const igData = response.data;
        // console.log(igData);
    
        //Create "li" content
        const igItem = document.createElement("li");
              igItem.className = "card";
        const thumbnail = igData.thumbnail_url;
        const author_name = igData.author_name;
        const author_url = igData.author_url;
        const title = igData.title;
        
        igItem.innerHTML = igContent(thumbnail, author_name, author_url, title);
        instaCotaniner.prepend(igItem);
    })
    .catch((error) => {
        // handle error
        console.log(error);
    });

    // Instagram Post Content Template
    function igContent(thumbnail, author_name, author_url, title) {
      return '<div class="social-feed-element" social-feed-id="'+ postID[j] +'"> \
        <div class="content"> \
            <a class="pull-left" href="'+ author_url +'" target="_blank"> \
                <img class="media-object" src="img/social/icon-ig.png"> \
            </a> \
            <div class="media-body"> \
                <p> \
                  <a class="author-title-link" href="'+ author_url +'" target="_blank"> \
                    <span class="author-title">'+ author_name +'</span> \
                  </a> \
                </p> \
                <div class="text-wrapper"> \
                    <p class="social-feed-text"><span>'+ title +'</span> <a href="'+ igPostLink + postID[j] +'" target="_blank" class="read-button">read more</a></p> \
                </div> \
            </div> \
        </div> \
        <div class="social-post"> \
          <img class="attachment" src="'+ thumbnail +'"> \
          <a class="social-post-link" href="'+ igPostLink + postID[j] +'" target="_blank"> \
            <img class="social-play" src="img/social/icon-ig-play.png"> \
          </a> \
        </div> \
      </div>';
    }
  }
  // window.igLoaded.resolve();
}


/**
 * Enable smooth anchor scrolling.
 */
function enableScrollTo() {
  const moveTo = new MoveTo();

  // Collect elements
  const links = Array.from(document.querySelectorAll('[data-smooth-scroll]'));
  if (!links) { return; }

  // Activate moveto listener for each element
  links.forEach((link) => {
    const targetId = link.getAttribute('href').substr(1);
    const targetElement = targetId == ''
      ? document.documentElement
      : document.getElementById(targetId);

    link.addEventListener('click', (e) => {
      e.preventDefault();
      moveTo.move(targetElement);
    });
  });

  return links;
}

/**
 * Enables the form.
 */
function enableForm() {

  // Define form options
  const options = {
    submitFn: (inputs) => {
      return new Promise((resolve, reject) => {
        // Collect values
        const values = inputs.reduce((acc, val) => {
          if (val.type === 'checkbox') {
            acc[val.name] = val.checked
          } else {
            acc[val.name] = val.value;
          }
          return acc;
        }, {});

        // Map values to the API's signature
        const payload = {
          uuid: 'B88CF84B-EDFB-6B15-D587-B787E6F394B0',
          campaign_code: 'SOW_PROSPEROUS',
          firstname: values['firstname'],
          lastname: values['lastname'],
          age: values['age'],
          gender: values['gender'],
          contactno: values['contact'],
          email: values['email'],
          address_1: values['mailing'],
          online_reference: values['url'],
          pdpa: values['pdpa'] ? 1 : 0,
        }

        // Create FormData object
        const formData = new FormData();
        Object.keys(payload).forEach(key => {
          formData.append(key, payload[key]);
        });
  
        // Submit AJAX request to the API backend
        const request = axios({
          method: 'post',
          url: 'https://sm-admin.forefront.international/server/api/registration',
          data: formData,
          config: {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        })
  
        // Handle success
        request.then((response) => {
          if (response.data.success) {
            resolve();
          } else {
            reject(response.data.error);
          }
        });

        // Handle errors
        request.catch((error) => {
          reject(error);
        });
      })
    },
    onSuccess: () => {
      foresight.send({
        category: 'Campaign',
        action: 'Submit Entry'
      });
    },
    onError: () => {
      foresight.send({
        category: 'Campaign',
        action: 'Submit Failed'
      });
    }
  }

  const form = new Form(document.getElementById('submit-form'), options);

  document.getElementById('form-reset').addEventListener('click', () => form.reset());

}